"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * When trying to use a ref within a hook, you might be tempted to try useRef. However, doing so
 * can lead to issues, "because an object ref doesn’t notify us about changes to the current ref value.
 * Using a callback ref ensures that even if a child component displays the measured node later (e.g. in response to a click),
 * we still get notified about it in the parent component and can update the measurements" (from react docs listed below).
 *
 * This helper takes advantage of the useCallback effect to provide an updated value for a ref.
 *
 * Usage:
 *
 *     const [myRef, setMyRef] = useRefCallback();
 *     useEffect(() => {
 *       doSomethingWithRef(myRef.current);
 *     });
 *
 *     ...
 *
 *     <div ref={setMyRef} />
 *
 * React Docs for more details:
 * https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
 */
var useRefCallback = function useRefCallback() {
  var _useState = (0, _react.useState)({
      current: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    customNode = _useState2[0],
    setCustomNode = _useState2[1];
  var ref = (0, _react.useCallback)(function (node) {
    setCustomNode({
      current: node
    });
  }, []);
  return [customNode, ref];
};
var _default = exports["default"] = useRefCallback;